import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App'
import '@/index.css'
import '@/app.css'
import { RouterProvider } from '@/context/RouterContext'
import { ToastProvider } from '@/context/ToastContext'
import { I18nProvider } from '@/context/I18nContext'
import { AuthProvider } from '@/context/AuthContext'
import { handleOAuthCallback, isOAuthCallback } from '@shared/auth/oauth';
import { initErrorReporter } from '@shared/error-reporter';
import { ErrorBoundary } from '@shared/ErrorBoundary';
import { getAuthToken } from '@/api/client';
// Initialize client error reporting — captures unhandled errors and forwards to backend.
initErrorReporter({ getAuthToken });

// Handle OAuth callback before React renders.
if (isOAuthCallback()) {
  await handleOAuthCallback('Telemetry Portal');
} else {
  // Normal app boot
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <I18nProvider>
          <AuthProvider>
            <RouterProvider>
              <ToastProvider bottomOffset>
                <App />
              </ToastProvider>
            </RouterProvider>
          </AuthProvider>
        </I18nProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  )
}

